import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private currentTheme: 'light' | 'dark' = 'light';

  constructor() {
    this.initTheme();
  }

  private initTheme(): void {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
    if (savedTheme) {
      this.setTheme(savedTheme);
    } else {
      this.setTheme('light'); // Default to light theme
    }
  }

  toggleTheme(): void {
    const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  private setTheme(theme: 'light' | 'dark'): void {
    const body = document.body;
    const oppositeTheme = theme === 'light' ? 'dark' : 'light';

    body.classList.remove(`${oppositeTheme}-theme`);
    body.classList.add(`${theme}-theme`);

    this.currentTheme = theme;
    localStorage.setItem('theme', theme);
  }

  getCurrentTheme(): 'light' | 'dark' {
    return this.currentTheme;
  }
}